import assetFetchers from '@/api/fetchers/content-studio/asset';
import useReactQuery from '@/hooks/use-react-query';
import {ASSET_FILTERS, CONTENT_LAB} from '../consts';

function useFiltersQuery() {
  return useReactQuery({
    queryKey: [CONTENT_LAB, ASSET_FILTERS],
    queryFn: async () => {
      const response = await assetFetchers.getFilters();
      return response;
    },
  });
}

export default useFiltersQuery;
